module.exports = __webpack_public_path__ + "static/media/HBTC-USDT.6d6344fc.png";